<template>
	<el-button v-permission="permission" :size="size" :type="btnObj.menuColor" :icon="btnObj.menuIcon" v-bind="$attrs" v-on="$listeners">
		{{ buttonText }}
	</el-button>
</template>

<script>
export default {
	name: "KtButton",
	props: {
		permission: {
			type: String,
			required: true
		},
		size: {
			type: String,
			default: "small"
		}
	},
	computed: {
		btnObj() {
			return this.$permissionStore.state.permission[this.permission] || {};
		},
		buttonText() {
			// 提供更灵活的文本处理
			return this.btnObj.menuName ? this.btnObj.menuName.split("-")[0] : "默认按钮";
		}
	}
};
</script>
